// AIAgentsPreviewV3 — MOCKED section. Real AI Agents land in WAVE 5.
//
// The endpoint `/api/dashboard-v3/agents-preview` returns 3 hardcoded
// cards with `mock:true`. We render a small demo banner and a disabled
// "Esplora tutti" CTA with a tooltip pointing to the WAVE 5 milestone.
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { apiFetch } from "@/lib/api";
import AIAgentCardV3 from "../components/AIAgentCardV3";

export default function AIAgentsPreviewV3() {
    const { t } = useTranslation("dashboard_v3");
    const [items, setItems] = useState([]);

    useEffect(() => {
        let mounted = true;
        (async () => {
            try {
                const data = await apiFetch("/dashboard-v3/agents-preview");
                if (mounted && Array.isArray(data?.items)) setItems(data.items);
            } catch {
                if (mounted) setItems([]);
            }
        })();
        return () => { mounted = false; };
    }, []);

    const statusLabelFor = (statusKey) => {
        if (statusKey === "active") return t("ai_agents.status_active");
        if (statusKey === "standby") return t("ai_agents.status_standby");
        return t("ai_agents.status_inactive");
    };

    return (
        <section aria-labelledby="ai-agents-heading" className="mt-10">
            <div className="flex items-start justify-between flex-wrap gap-2 mb-3">
                <div>
                    <h2
                        id="ai-agents-heading"
                        className="text-[11px] uppercase tracking-widest text-[#CCCCCC] font-semibold"
                    >
                        {t("ai_agents.headline")}
                    </h2>
                    <p className="mt-1 text-xs text-[#71717A]">{t("ai_agents.sub")}</p>
                </div>
                <span
                    className="text-[10px] uppercase tracking-widest px-2 py-1 rounded-full font-semibold"
                    style={{
                        backgroundColor: "rgba(204, 204, 204,0.12)",
                        color: "#CCCCCC",
                    }}
                    data-testid="dashboard-v3-agents-mock-banner"
                >
                    {t("ai_agents.demo_banner")}
                </span>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {items.map((it, i) => (
                    <AIAgentCardV3
                        key={it.id}
                        testId={`dashboard-v3-agent-${it.id}`}
                        name={t(`ai_agents.agents.${it.id}.name`)}
                        description={t(`ai_agents.agents.${it.id}.description`)}
                        statusKey={it.status}
                        statusLabel={statusLabelFor(it.status)}
                        color={it.color}
                        progressPct={it.progress_pct}
                        delay={i * 0.05}
                    />
                ))}
            </div>

            {/* Disabled CTA — routes to WAVE 5 */}
            <div className="mt-4 flex flex-col items-start gap-1">
                <button
                    type="button"
                    disabled
                    aria-disabled="true"
                    title={t("ai_agents.cta_tooltip")}
                    data-testid="dashboard-v3-agents-cta-disabled"
                    className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-xs font-medium text-[#CCCCCC] cursor-not-allowed opacity-70"
                    style={{ backgroundColor: "#1A1A1A", border: "1px dashed #374151" }}
                >
                    {t("ai_agents.cta_disabled")} · 🔒
                </button>
                <p className="text-[10px] text-[#71717A]">{t("ai_agents.cta_roadmap")}</p>
            </div>
        </section>
    );
}
